import { MutationTree } from 'vuex';
import { FlowDesignerState } from '..';
import { SET_PATHS, ADD_PATH, REMOVE_PATH, UPDATE_PATH, SET_CURRENT_PATH, ADD_FLOW } from './mutationTypes';
import { PathViewModel } from '@/features/bots/models/designer';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';

export const mutations: MutationTree<FlowDesignerState> = {
  [SET_PATHS](state, paths: PathViewModel[]) {
    state.currentFlow.paths = paths;
  },

  [SET_CURRENT_PATH](state, pathId: string) {
    state.currentPathId = pathId;
  },

  [ADD_PATH](state, path: PathViewModel) {
    state.currentFlow.paths.push(path);
  },

  [REMOVE_PATH](state, pathId: string) {
    const indexToRemove = state.currentFlow.paths.findIndex((p) => p.id === pathId);
    if (indexToRemove === -1) {
      return;
    }
    state.currentFlow.paths.splice(indexToRemove, 1);
  },

  [UPDATE_PATH](state, updatedPath: PathViewModel) {
    const pathToUpdate = state.currentFlow.paths.find((p) => p.id === updatedPath.id);
    if (pathToUpdate === undefined) {
      return;
    }
    pathToUpdate.name = updatedPath.name;
    pathToUpdate.states = updatedPath.states;
  },

  [ADD_FLOW](state, flow: FlowListItemViewModel) {
    state.flows.push(flow);
  },
};
